export const API_ENDPOINT = process.env.REACT_APP_BACKEND_URL;
export const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;
export const WEB_URL = process.env.REACT_APP_WEB_URL;
